import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/1ca92b05a3a8fac4d9f8062f2b2f945d.png" 
                  alt="まごころヘルパー ロゴ" 
                  className="w-12 h-12 object-contain"
                />
              </div>
              <span className="logo-watercolor text-white whitespace-nowrap">まごころヘルパー</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              逗子・葉山地域に根ざした訪問介護ステーション。一人ひとりに寄り添う、まごころの介護を提供しています。
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">サイトマップ</h3>
            <nav className="space-y-3">
              <Link to="/" className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                トップ
              </Link>
              <Link to="/about" className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                まごころヘルパーについて
              </Link>
              <Link to="/service" className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                サービス内容
              </Link>
              <Link to="/recruit" className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                採用情報
              </Link>
              <Link to="/company" className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                法人・アクセス情報
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">お問い合わせ</h3>
            <div className="space-y-4">
              <a href="tel:046-845-4175" className="flex items-center gap-3 text-2xl font-bold hover:text-cyan-400 transition-colors cursor-pointer">
                <i className="ri-phone-line"></i>
                046-845-4175
              </a>
              <p className="text-sm text-gray-400">受付時間:平日 9:00〜18:00</p>
              <a href="mailto:info@reria.co.jp" className="block text-gray-400 hover:text-cyan-400 transition-colors underline cursor-pointer">
                info@reria.co.jp
              </a>
              <a
                href="https://ws.formzu.net/dist/S274768490/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 bg-cyan-500 text-white rounded-full font-medium hover:bg-cyan-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                お問い合わせフォーム
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400 text-center md:text-left">
              <p>© 2025 株式会社レリア</p>
              <p className="text-xs mt-1">介護保険事業所番号:1472501285 | 指定年月日:2025年08月01日</p>
            </div>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors underline cursor-pointer">
                プライバシーポリシー
              </Link>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
